import { PropsWithChildren } from 'react';
import * as Sentry from '@sentry/react';
import ErrorBoundaryLayout from './ErrorBoundaryLayout/ErrorBoundaryLayout';

export default function RootErrorBoundary({
  children,
}: PropsWithChildren<unknown>) {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorBoundaryLayout />}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
